import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { fetchAuthSession } from "aws-amplify/auth";
import { Box, CircularProgress } from "@mui/material";

export function AuthCallbackPage() {
  const navigate = useNavigate();
  useEffect(() => {
    const tick = async () => {
      try {
        const session = await fetchAuthSession();
        navigate(session.tokens?.idToken ? "/" : "/auth", { replace: true });
      } catch {
        navigate("/auth", { replace: true });
      }
    };
    // Amplify processes the OAuth code on Hub events; give it a moment.
    const t = setTimeout(tick, 800);
    return () => clearTimeout(t);
  }, [navigate]);
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <CircularProgress />
    </Box>
  );
}
